import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { I18nProvider } from './i18n';
import ErrorBoundary from './utils/ErrorBoundary';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

if (process.env.NODE_ENV === 'development') {
  const OriginalRO = window.ResizeObserver;
  if (OriginalRO) {
    window.ResizeObserver = class ResizeObserver extends OriginalRO {
      constructor(callback) {
        super((entries, observer) => {
          requestAnimationFrame(() => callback(entries, observer));
        });
      }
    };
  }

  const ignoreRoError = (e) => {
    const msg = e?.message || e?.reason?.message || '';
    if (msg.includes('ResizeObserver loop')) {
      e.preventDefault?.();
      e.stopImmediatePropagation?.();
    }
  };
  window.addEventListener('error', ignoreRoError);
  window.addEventListener('unhandledrejection', ignoreRoError);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const AppTree = (
  <BrowserRouter>
    <I18nProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </I18nProvider>
  </BrowserRouter>
);

root.render(
  process.env.NODE_ENV === 'development' ? AppTree : <React.StrictMode>{AppTree}</React.StrictMode>
);
